import React, { useContext } from 'react';
import { ResponsiveContext } from '../../contexts/ResponsiveContext';
import GoogleMapsImage from '../../assets/img/google-maps.webp';
import GoogleMapsImageMobile from '../../assets/img/google-maps-mobile.webp';

const ContactInfo = () => {
  const { is600, is900, is1100 } = useContext(ResponsiveContext);

  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <div className='d-flex row align-content-center justify-content-center'>
        <h6
          className={`${
            is1100 ? 'fs-2' : 'fs-4'
          } fw-bold text-muted fst-italic`}
          style={{
            boxShadow:
              'rgba(255, 120, 3, 0.4) 0px 5px, rgba(255, 120, 3, 0.3) 0px 10px, rgba(255, 120, 3, 0.2) 0px 15px, rgba(255, 120, 3, 0.1) 0px 20px, rgba(255, 120, 3, 0.05) 0px 25px',
            width: '80%',
            marginTop: is1100 ? '30px' : '80px',
          }}
        >
          DÓNDE ESTAMOS...
        </h6>
      </div>
      <div className='contactInfo container'>
        <div
          className='row d-flex flex-row justify-content-between'
          style={{ width: '100%' }}
        >
          <div className='col-12 contact-Box'>
            <div className='d-flex justify-content-center'>
              <h6
                className={`${
                  is900 ? 'fs-4' : 'fs-6'
                } fw-bold text-muted fst-italic text-center`}
                style={{
                  width: is1100 ? '70vw' : '80vw',
                  marginBottom: is1100 ? '50px' : '30px',
                }}
              >
                Tienda Deportes Sporting - Calle Virgen del Lluc nº4, 28027
              </h6>
            </div>
            <div className='d-flex justify-content-center'>
              <h6
                className={`${
                  is900 ? 'fs-4' : 'fs-6'
                } fw-bold text-muted fst-italic text-center`}
                style={{
                  width: is1100 ? '70vw' : '80vw',
                  marginBottom: is1100 ? '50px' : '30px',
                }}
              >
                Lunes a viernes de 10:00h a 13:30h y 17:00h a 20:00h
                <br />
                Sábado de 10:00h a 13:45h
              </h6>
            </div>
            <div className='d-flex justify-content-center'>
              <img
                src={is600 ? GoogleMapsImage : GoogleMapsImageMobile}
                alt='Google Maps'
                style={{
                  height: 'auto',
                  width: is1100 ? '70vw' : '80vw',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  openInNewTab(
                    'https://www.google.es/maps/place/Deportes+Sporting/@40.4343051,-3.6576217,17z/data=!3m1!4b1!4m5!3m4!1s0xd422f49d0a10f07:0x1c2c61810680bb2c!8m2!3d40.434301!4d-3.655433?hl=es'
                  )
                }
                loading='lazy'
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactInfo;
